export default __webpack_public_path__ + "static/media/design.180d305e.svg";